import dynamic from "next/dynamic";
import {DrupalVideoMedia} from "../../../types/hygiena-types";
import {useContext} from "react";
import {ModalContext} from "../../../context/modal-context";
const VideoSlider = dynamic(() => import("../../organisms/slider").then((mod) => mod.TrainingVideosSlider));

export function ParagraphVideoSlider ({paragraph, ...props}) {
  const {setOpenModal, setOpenSmallModal, setOpenModalContent, setOpenSmallModalContent} = useContext(ModalContext);
  const videos: DrupalVideoMedia[] = paragraph?.field_video_slider_videos?.filter(item => item?.field_media_oembed_video?.length > 0) ?? [];
  if (!videos.length) return <></>

  return (
    <div className="paragraph--video-slider">
      <VideoSlider videos={videos} openModal={setOpenModal} openModalContent={setOpenModalContent} />
    </div>
  )
}